/* eslint-disable no-unused-vars */
/**
 * need
 * INSERT
 * DELETE
 * UPDATE
 */
import { store } from "@/store/store";

import { CONFIG_API } from "@/plugins/axios";
import { connectMQTT } from "@/services/mqtt/configuration";

import { getRealtimeReferenceList } from "./RealtimeMeasureRef";
import { getRealtimeMeasures } from "./RealtimeMeasure";

import { getConstantReferenceList } from "./ConstantMeasureRef";
import { getConstantMeasures } from "./ConstantMeasure";

import { getHistoricalReferenceList } from "./HistoricalMeasureRef";
import { getHistoricalMeasures } from "./HistoricalMeasure";
import { default as HistoricalArray } from "./HistoricalArray";

import { getAlarmReferenceList } from "./AlarmRef";
import { getAlarms } from "./Alarm";

import { getSpecificMeasures } from "./SpecificMeasure";

import { getGoals } from "./Goals";
import { default as GoalsArray } from "./GoalsArray";

import { getFilters } from "./Filter";

export default class Component {
    constructor(component) {
        if (component) {
            this.id = component.id;
            this.name = component.name;
            this.featureName = component.feature_name;
            this.description = component.description;
            this.category = component.category;

            this.realtimeMeasures = [];
            this.realtimeRefereces = [];
            this.constantMeasures = [];
            this.constantRefereces = [];
            this.historicalMeasures = [];
            this.historicalReferences = [];
            this.alarms = [];
            this.alarmRefereces = [];
            this.specificMeasures = [];
            this.goals = [];
            this.filters = [];

            this.measuresTopics = [];
            this.alarmsTopics = [];

            this.clientMQTT = undefined;
        }
    }

    connectMQTT(forceNewConnection = false) {
        if (!this.clientMQTT || forceNewConnection) {
            this.clientMQTT = connectMQTT();
        }
    }

    groupItems(list = [], key) {
        let object = {};

        list.forEach(item => {
            let value = item[key];
            if (!object[value]) {
                object[value] = [];
            }
            object[value].push(item);
        });
        return object;
    }

    getAttributeList(array, key) {
        let list = [];
        array.forEach(item => {
            if (Object.hasOwnProperty.call(item, key)) {
                if (Array.isArray(item[key])) {
                    list = list.concat(item[key]);
                } else {
                    list.push(item[key]);
                }
            }
        });
        return list;
    }

    getTabs(params = { value: "keys", text: "text" }) {
        if (!("text" in params) || !("value" in params)) return [];
        return this.parseSpecific(params);
    }
    getHeaders(params = { value: "value", text: "text" }) {
        if (!("text" in params) || !("value" in params)) return [];
        return this.parseSpecific(params);
    }
    /**
   * Parse list of reference values to a object format
   * makes easier getting data to build table's headers 
   * and tabs
   * @param {Object} params 
   * @returns {Array} List of objects
   */
    parseSpecific(params = {}) {
        const searchList = Object.values(params);
        let specifics = [];
        this.specificMeasures.forEach((m) => m.name && searchList.includes(m.name) && specifics.push(m));

        if (!specifics || !specifics.length) return [];

        const keys = Object.keys(params);
        const pairs = [];
        specifics.forEach(({ name, referenceValue }) => {
            referenceValue.forEach((value, i) => {
                const key = keys.find(key => params[key] === name);
                if (pairs[i]) {
                    pairs[i][key] = value;
                } else {
                    const object = {};
                    object[key] = value;
                    pairs.push(object);
                }
            });
        });
        return pairs;
    }

    async setFilters() {
        this.filters = await getFilters({ component: this.id });
    }

    formatParams(params = {}, names = []) {
        if (!params.source) {
            // default source set to plant
            const source = "plant";
            params = { source, ...params };
        }
        if ("names" in params || "name" in params) {
            return params;
        }
        if (names.length) {
            params = { names, ...params };
        }
        return params;
    }
    /**
   * Set reference attributes on instances
   * @param {Array} instances Array of class instances
   * @param {Array} references Array of class instances for measurement|alarms references
   * @param {Function} callback Get item after setAttributes call
   * @returns Array of instances 
   */
    setAttributesInstances(instances = [], references = [], callback) {
        return instances.map((item, index) => {
            let ref = references.find(e => e.referenceValue.includes(item.name));
            if (ref) {
                item.setAttributes(ref);
                item = callback(item, ref, index);
            }
            return item;
        });
    }

    setMQTTInstances(instances = [], mqtt = this.clientMQTT) {
        return instances.map(item => {
            item.setMQTT(mqtt);
            return item;
        });
    }
    async setRealtime(params = {}, callback = (item) => item) {
        this.realtimeRefereces = await getRealtimeReferenceList({ component: this.id });

        let names = this.getAttributeList(this.realtimeRefereces, "referenceValue");
        params = this.formatParams(params, names);

        const instances = await getRealtimeMeasures(params);
        const realtime = this.setAttributesInstances(instances, this.realtimeRefereces, callback);
        this.realtimeMeasures = this.setMQTTInstances(realtime);
        return this.realtimeMeasures;
    }

    async setPaginateRealtime(params = {}, callback = (item) => item) {
        this.realtimeRefereces = await getRealtimeReferenceList({ component: this.id });

        let names = this.getAttributeList(this.realtimeRefereces, "referenceValue");
        params = this.formatParams(params, names);
        const data = await getRealtimeMeasures(params);
        data.results = this.setAttributesInstances(data.results, this.realtimeRefereces, callback);
        this.realtimeMeasures = this.setMQTTInstances(data.results);
        return data;
    }

    async setConstant(params = {}, callback = item => item) {
        this.constantRefereces = await getConstantReferenceList({ component: this.id });

        let names = this.getAttributeList(this.constantRefereces, "referenceValue");
        params = this.formatParams(params, names);

        const instances = await getConstantMeasures(params);
        this.constantMeasures = this.setAttributesInstances(instances, this.constantRefereces, callback);

        return this.constantMeasures;
    }

    async setPaginateConstant(params = {}, callback = item => item) {
        this.constantRefereces = await getConstantReferenceList({ component: this.id });

        let names = this.getAttributeList(this.constantRefereces, "referenceValue");
        params = this.formatParams(params, names);

        const data = await getConstantMeasures(params);
        this.constantMeasures = this.setAttributesInstances(data.results, this.constantRefereces, callback);

        return data;
    }

    async setAlarm(params, callback = item => item) {
        this.alarmRefereces = await getAlarmReferenceList({ component: this.id });

        let names = this.getAttributeList(this.alarmRefereces, "referenceValue");
        params = this.formatParams(params, names);

        const instances = await getAlarms(params);
        const alarms = this.setAttributesInstances(instances, this.alarmRefereces, callback);
        this.alarms = this.setMQTTInstances(alarms);

        return this.alarms;
    }
    /**
    * Wrong name, should it be "setAlarm" to maintain the pattern
    * Use setAlarm instead
    * @deprecated
    */
    async setAlarms(params = {}, callback = item => item) {
        this.alarmRefereces = await getAlarmReferenceList({ component: this.id });

        let names = this.getAttributeList(this.alarmRefereces, "referenceValue");
        params = this.formatParams(params, names);

        const instances = await getAlarms(params);
        const alarms = this.setAttributesInstances(instances, this.alarmRefereces, callback);
        this.alarms = this.setMQTTInstances(alarms);

        return this.alarms;
    }

    async setPaginateAlarms(params = {}, callback = item => item) {
        this.alarmRefereces = await getAlarmReferenceList({ component: this.id });

        let names = this.getAttributeList(this.alarmRefereces, "referenceValue");
        params = this.formatParams(params, names);

        const data = await getAlarms(params);
        data.results = this.setAttributesInstances(data.results, this.alarmRefereces, callback);
        this.alarms = this.setMQTTInstances(data.results);

        return data;
    }

    async setSpecific() {
        this.specificMeasures = await getSpecificMeasures({ component: this.id });
    }

    async setHistorical(params = {}, callback = item => item) {
        this.historicalReferences = await getHistoricalReferenceList({ component: this.id });

        let names = this.getAttributeList(this.historicalReferences, "referenceValue");
        params = this.formatParams(params, names);

        const instances = await getHistoricalMeasures(params);
        this.historicalMeasures = this.setAttributesInstances(instances, this.historicalReferences, callback);
        return this.historicalMeasures;
    }

    async setPaginateHistorical(params = {}, callback = item => item) {
        this.historicalReferences = await getHistoricalReferenceList({ component: this.id });

        let names = this.getAttributeList(this.historicalReferences, "referenceValue");
        params = this.formatParams(params, names);

        const data = await getHistoricalMeasures(params);
        this.historicalMeasures = this.setAttributesInstances(data.results, this.historicalReferences, callback);
        return data;
    }

    async setHistoricalData(params) {
        let historicalArray = new HistoricalArray(this.historicalMeasures);
        this.historicalMeasures = await historicalArray.setData(params);
        return this.historicalMeasures;
    }

    async setHistoricalDataMonthly(params) {
        let historicalArray = new HistoricalArray(this.historicalMeasures);
        this.historicalMeasures = await historicalArray.setDataMonthly(params);
        return this.historicalMeasures;
    }

    historicalSum(list) {
        let instance = new HistoricalArray();
        if (list) {
            return instance.sum(list);
        }
        return instance.sum(this.historicalMeasures);
    }

    async setGoals(params) {
        this.goals = await getGoals(params);
    }

    async setGoalsData(params) {
        let goalsArray = new GoalsArray(this.goals);
        this.goals = await goalsArray.setValues(params);
        return this.goals;
    }

    /**
   * Performs the specified action for each element in an array.
   * @param callback  A function that accepts up to three arguments.
   */
    forEachRealtime(callback = (value, index, array = []) => value) {
        this.realtimeMeasures.forEach((m, i, array) => callback(m, i, array));
    }

    forEachSpecific(callback = (value, index, array = []) => value) {
        this.specificMeasures.forEach((m, i, array) => callback(m, i, array));
    }
    /**
   * Returns the value of the first element in the array where predicate is true, and
   * undefined otherwise 
   * @param predicate findRealtime calls predicate once for each element of the array,
   * until it finds one where predicate returns true. If element is found return it.
   * Otherwise, return undefined 
   * @returns {RealtimeMeasure | undefined}
   */
    findRealtime(callback = (value, index, array = []) => value) {
        return this.realtimeMeasures.find((m, i, array) => callback(m, i, array));
    }
    findAlarm(callback = (value, index, array = []) => value) {
        return this.alarms.find((m, i, array) => callback(m, i, array));
    }
    findSpecific(callback = (value, index, array) => value) {
        return this.specificMeasures.find((m, i, array) => callback(m, i, array));
    }
    findHistorical(callback = (value, index, array) => value) {
        return this.historicalMeasures.find((m, i, array) => callback(m, i, array));
    }
    findConstant(callback = (value, index, array) => value) {
        return this.constantMeasures.find((m, i, array) => callback(m, i, array));
    }

    subscribeAlarms() {
        this.alarmsTopics = [];
        this.alarms.forEach(alarm => {
            alarm.setMQTT(this.clientMQTT);
            if (alarm.checkTopic()) this.alarmsTopics.push(alarm.topic);
        });
        if (this.alarmsTopics.length > 0) this.clientMQTT.subscribe(this.alarmsTopics);
    }

    unsubscribeAlarms() {
        if (this.alarmsTopics.length > 0) this.clientMQTT.unsubscribe(this.alarmsTopics);
        this.alarms.forEach(alarm => {
            alarm.setMQTT(this.clientMQTT);
            alarm.deleteTopic();
        });
        this.alarmsTopics = [];
    }

    subscribeMeasures() {
        this.measuresTopics = [];
        this.realtimeMeasures.forEach(measure => {
            measure.setMQTT(this.clientMQTT);
            if (measure.checkTopic()) this.measuresTopics.push(measure.topic);
        });
        if (this.measuresTopics.length > 0) this.clientMQTT.subscribe(this.measuresTopics);
    }

    unsubscribeMeasures() {
        if (this.measuresTopics.length > 0) this.clientMQTT.unsubscribe(this.measuresTopics);
        this.realtimeMeasures.forEach(measure => {
            measure.setMQTT(this.clientMQTT);
            measure.deleteTopic();
        });
        this.measuresTopics = [];
    }

    subscribe() {
        this.subscribeMeasures();
        this.subscribeAlarms();
    }

    unsubscribe() {
        this.unsubscribeMeasures();
        this.unsubscribeAlarms();
    }
    /**
     * Subscribe to topics passed as props. Way to use subscribe inside a component passing topics outside of it
     * @param {RealtimeMeasure | Alarm | String} data can be one ou multiple instances of models or strings
     */
    subscribeTo(data) {
        if (!data) return;
        if (Array.isArray(data) && !data.length) return;
        let list = !Array.isArray(data) ? [data] : data;
        const topics = list.map(e => "topic" in e ? e.topic : e).filter(Boolean);
        this.measuresTopics = this.measuresTopics.concat(topics);

        if (this.measuresTopics.length) {
            this.clientMQTT.subscribe(topics);
        }
    }

}

export async function getComponent(params) {
    try {
        const headers = {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            Authorization: "JWT " + store.getters.getToken
        };
        const config = { headers };
        let res;
        if (typeof params === "number") {
            res = await CONFIG_API.get(`components/${params}/`, config);
            if (res && res.status == 200) {
                return new Component(res.data);
            }
        } else {
            res = await getComponents(params);
            return res[0];
        }
    } catch (e) {
        console.error(e);
        return null;
    }
}

export async function getComponents(params) {
    try {
        const headers = {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            Authorization: "JWT " + store.getters.getToken
        };
        const config = { headers, params };
        let res = await CONFIG_API.get("components/", config);
        if (res && res.status == 200) {
            let data = res.data.map(e => new Component(e));
            return data;
        }
        throw res;
    } catch (e) {
        console.error(e);
        return [];
    }
}
